module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_desktop_f646a65bbbfe027294f945240e8ee41f.webp";